module.exports = __webpack_public_path__ + "img/1440.db711930.jpg";